/**
 * Cookie Consent Management Platform - API 接口
 */

import { ConsentChoices, getOrCreateAnonId } from './cmpStorage';

// 配置接口响应
export interface ConsentConfigResponse {
  policyVersion: string;
  categories?: {
    necessary?: { name: string; description: string };
    functional?: { name: string; description: string };
    analytics?: { name: string; description: string };
    advertising?: { name: string; description: string };
  };
}

// Cookie Policy 内容响应
export interface CookiePolicyResponse {
  policyVersion: string;
  contentMarkdown: string;
}

// 获取当前策略版本和分类配置（直接查询数据库）
export async function fetchConsentConfig(): Promise<ConsentConfigResponse> {
  try {
    const res = await fetch('/api/cookie-policy', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const data = await res.json();
    return {
      policyVersion: data.policyVersion || '',
    };
  } catch (e) {
    console.warn('[CMP] fetchConsentConfig failed:', e);
    // 返回默认值，防止阻塞
    return { policyVersion: '' };
  }
}

// 上报同意选择（写入 putong-operation）
export async function postConsent(
  policyVersion: string,
  consent: ConsentChoices
): Promise<boolean> {
  try {
    const anonId = getOrCreateAnonId();
    const res = await fetch('/api/consent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CMP-ANON-ID': anonId,
      },
      body: JSON.stringify({
        policyVersion,
        consent,
      }),
    });
    return res.ok;
  } catch (e) {
    console.warn('[CMP] postConsent failed:', e);
    return false;
  }
}

// 获取 Cookie Policy Markdown 内容（直接查询数据库）
export async function fetchCookiePolicyContent(): Promise<CookiePolicyResponse | null> {
  try {
    const res = await fetch('/api/cookie-policy', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const data = await res.json();
    return {
      policyVersion: data.policyVersion || '',
      contentMarkdown: data.contentMarkdown || '',
    };
  } catch (e) {
    console.warn('[CMP] fetchCookiePolicyContent failed:', e);
    return null;
  }
}

